import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Link, 
  IconButton,
  Divider 
} from '@mui/material';
import { 
  Facebook, 
  Instagram, 
  Twitter, 
  Phone, 
  Email, 
  LocationOn 
} from '@mui/icons-material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.main',
        color: 'white',
        py: 4,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
          <Box sx={{ flex: '1 1 300px' }}>
            <Typography variant="h6" gutterBottom>
              KMO Smile
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Cuidamos tu sonrisa con la más alta tecnología y profesionalismo.
              Más de 15 años de experiencia en odontología integral.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton color="inherit" size="small">
                <Facebook />
              </IconButton>
              <IconButton color="inherit" size="small">
                <Instagram />
              </IconButton>
              <IconButton color="inherit" size="small">
                <Twitter />
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ flex: '1 1 300px' }}>
            <Typography variant="h6" gutterBottom>
              Información de Contacto
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Phone sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">
                +57 314 662 8875
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <LocationOn sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">
                Clínica Medellín sede el poblado. Consultorio 710
              </Typography>
            </Box>
          </Box>

          <Box sx={{ flex: '1 1 300px' }}>
            <Typography variant="h6" gutterBottom>
              Horarios de Atención
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Lunes a Viernes: 8:00 - 18:00
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Sábados: 8:00 - 12:00
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Emergencias: 24/7
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              WhatsApp: +57 314 662 8875
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 3, borderColor: 'rgba(255, 255, 255, 0.2)' }} />

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="inherit">
            © {new Date().getFullYear()} KMO Smile. Todos los derechos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 